import { apiSlice } from '@/api/api.slice.tsx';

export interface WireTransferSetupResponse {
  clientSecret: string;
}

const curr = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createWireTransferSetup: builder.mutation<WireTransferSetupResponse, void>({
      query: () => ({
        url: '/create-wire-transfer-setup',
        method: 'POST',
      }),
      invalidatesTags: ['FundingPaymentMethod'],
    }),
  }),
});

export const { useCreateWireTransferSetupMutation } = curr;
